import { Injectable } from '@angular/core';
import { FormatToService } from 'app/consulta-mark-list/service/Validators/format-to.service';
import type { DynamicInputForm, OptionCombobox } from 'app/core/interfaces';
import { AvlaRestClientService } from 'base-angular-avla';
import { Observable } from 'rxjs';
import { HelperService } from 'shared-angular-components-avla';

@Injectable()
export class SinisterService {
  getDynamicFormInputsAtDateUrl = '/api-mark-list/getDynamicFormInputsAtDate';

  constructor(
    protected restClientService: AvlaRestClientService,
    protected _helperService: HelperService,
    protected formatToService: FormatToService
  ) {}

  getDynamicFormInputsAtDate(
    formName: string,
    toDate: string
  ): Observable<DynamicInputForm[]> {
    const queryString = {};

    if (formName) {
      queryString['formName'] = formName;
    }

    if (toDate) {
      queryString['toDate'] = toDate;
    }

    return this.restClientService.getList(
      this.getDynamicFormInputsAtDateUrl,
      null,
      queryString
    );
  }

  getOptionsCombobox(params): Observable<OptionCombobox[]> {
    return this.restClientService.getList(
      `/api-mark-list/getOptionsOfCombobox?codeCombobox=${params}&onlyEnabled=true`
    );
  }
}
